import { FileTypes, Frequency, PricePer, VolumeUnits, WeightUnits } from '@emi/shared/models';

export const pricePoints: Array<PricePer> = ['Sku', 'Unit'];
export const fileTypes: Array<FileTypes> = ['CSV', 'Excel'];
export const frequencyOptions: Frequency[] = ['Daily', 'Weekly', 'Monthly', 'Quarterly', 'Yearly'];
export const volumeOptions: Array<VolumeUnits> = ['fl oz', 'pt', 'l', 'cl', 'gal', 'ml'];
export const weightOptions: Array<WeightUnits> = ['oz', 'mg', 'kg', 'lb', 'g'];
